import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../ui';
import { SharedUiModule } from '../../shared/ui';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { ReportComponent } from './report.component';
import { FinancialDataReportComponent } from './financial-data-report.component';


@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    HttpClientModule,
    RouterModule
  ],
  declarations: [
    ReportComponent,
    FinancialDataReportComponent
  ],
  providers: [
  ],
})
export class ReportModule { }
